module.exports = __webpack_public_path__ + "static/img/about.687fa8e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/home/about.jpg
// module id = WHTe
// module chunks = 1